import { Characteristics, Consumption, InflateRequestMode } from '@sccs/types';
import { TranslationType } from '../../util/i18n';
import {
  OneSearchGraphQlVehicle,
  TypeContext,
  getEmissionData,
  getEmissionFootnotesString,
  getEngineDescriptionOneSearch,
  getFinalInspectionDate,
  getFuelType,
  getGearbox,
  technicalDataConfigurationForMarkets,
  type ParsedTechnicalData,
} from '../VehicleTechnicalDataUtils';

export const technicalDataParserOneSearch = (
  product: OneSearchGraphQlVehicle,
  market: string,
  language: string,
  mode: InflateRequestMode,
  translations: (key: string, dataset?: TranslationType) => string,
) => {
  const getConfiguredTechnicalData = (): Partial<ParsedTechnicalData> => {
    const parsedTechnicalData: Partial<ParsedTechnicalData> = {};

    const addIfConfiguredForMarket = (
      key: keyof ParsedTechnicalData,
      getValue: () => Characteristics | Consumption[] | string | null | undefined,
    ) => {
      if (technicalDataConfigurationForMarkets(key, market, TypeContext.ONESEARCH)) {
        const value = getValue();
        if (!value) return;
        if (key === 'engineDescription' || key === 'finalInspectionDate' || key === 'fuelType' || key === 'gearBox') {
          parsedTechnicalData[key] = value as Characteristics;
        }
        if (key === 'emissionData') {
          parsedTechnicalData[key] = value as Consumption[];
        }
        // FIXME: this conversion shouldn't be required. Footnotes are returned as a string by getEmissionFootnotesString
        // but are required as an object here?
        if (key === 'emissionFootnotes' && typeof value === 'string') {
          parsedTechnicalData[key] = value as unknown as Record<string, string>;
        }
      }
    };

    addIfConfiguredForMarket('engineDescription', () => getEngineDescriptionOneSearch(product, translations));
    addIfConfiguredForMarket('emissionData', () =>
      getEmissionData(product, TypeContext.ONESEARCH, language, translations, market),
    );
    addIfConfiguredForMarket('finalInspectionDate', () => getFinalInspectionDate(product, mode, TypeContext.ONESEARCH));
    addIfConfiguredForMarket('emissionFootnotes', () => getEmissionFootnotesString(product));
    addIfConfiguredForMarket('fuelType', () => getFuelType(product, TypeContext.ONESEARCH));
    addIfConfiguredForMarket('gearBox', () => getGearbox(product, TypeContext.ONESEARCH));

    return parsedTechnicalData;
  };

  return {
    getTechnicalData: getConfiguredTechnicalData,
  };
};
export { ParsedTechnicalData };
